/** @typedef {{all: string, [key:string]:string}} Response */

import { translate } from '../../../Internationalization';
import categories from '@mooveguru/yhh-shared-config/marketplace-categories.json';

export const defaultCategoryList = {
	all: translate('agent.pages.offers.view.all_categories'),
};

/**
 * @param {string[]} [categoryList]
 * @returns {Response}
 */
export default function mapVendorCategories(categoryList) {
	if (!categoryList?.length) {
		return defaultCategoryList;
	}

	/** @type {Response} */
	const categoryListObject = defaultCategoryList;

	categoryList.sort().forEach((assignedCategory) => {
		categoryListObject[assignedCategory] =
			/** @type {{[key: string]: string}} */
			(categories)[assignedCategory] ?? assignedCategory;
	});

	return categoryListObject;
}
